import React from 'react';

import { Dot, Lock } from 'react-bootstrap-icons';
import T from 'utils/useLocalizer';
import styles from '../style.module.scss';
import { IOrderStatus } from 'models/ordersModel';
import { Card, CardBody } from 'react-bootstrap';
import NotifyToggle from './NotifyToggle';
import { IWhatsAppTemplate } from 'models/whatsAppTemplateModel';
import { SmallCardSkeleton } from 'components/ui/skeleton/skeleton';
import { common } from 'utils/resources';

export interface Props {
  statuses: IOrderStatus[];
  waNotificationTemplates: IWhatsAppTemplate[];
  isLoadingTemplates: boolean;
  isLoadingStatuses: boolean;
}

const SystemStatusForm = ({ statuses, waNotificationTemplates, isLoadingTemplates, isLoadingStatuses }: Props) => {
  const confirmedStatus = statuses?.find((s) => s.orderSystemStatusId === 1);
  const cancelledStatus = statuses?.find((s) => s.orderSystemStatusId === 2);
  const completedStatus = statuses?.find((s) => s.orderSystemStatusId === 3);

  const resources = {
    startStatusLabel: T('orders.order.settings.start.status.label'),
    finalStatusLabel: T('orders.order.settings.final.status.label'),
    startToggle: T('orders.order.settings.start.status.toggle.label'),
    finalToggle: T('orders.order.settings.final.status.toggle.label'),
    noData: T(common.noData),
  };

  return (
    <div className="d-flex flex-wrap gap-3">
      {/* Order Start Status */}
      <div className="py-3 p-md-3">
        <span className="text-muted">{resources.startStatusLabel}</span>
        {isLoadingStatuses ? (
          <Card className={`${styles.statusCard} rounded-4 bg-white`}>
            <CardBody>
              <SmallCardSkeleton />
            </CardBody>
          </Card>
        ) : !confirmedStatus ? (
          <Card className={`${styles.statusCard} rounded-4 bg-white`}>
            <CardBody className="text-center">{resources.noData}</CardBody>
          </Card>
        ) : (
          <Card className={`${styles.statusCard} ${styles.confirmedStatus} rounded-4`}>
            <CardBody className="d-flex align-items-center gap-2 justify-content-between py-2 px-3">
              <div className="fw-bold">
                <Lock className="me-2 text-muted" />{' '}
                <span>
                  <Dot width={32} height={32} />
                  {confirmedStatus?.name}
                </span>
              </div>
              <span className="text-muted fw-bold text-uppercase">{resources.startToggle}</span>
            </CardBody>
          </Card>
        )}
      </div>

      {/* Order Final Status */}
      <div className="py-3 p-md-3">
        <span className="text-muted">{resources.finalStatusLabel}</span>
        {/* <div className="d-flex flex-wrap gap-4 align-items-start"> */}
        {/* Completed Status */}
        {!isLoadingStatuses && statuses.length <= 0 ? (
          <Card className={`${styles.statusCard} rounded-4 bg-white`}>
            <CardBody className="text-center">{resources.noData}</CardBody>
          </Card>
        ) : isLoadingStatuses ? (
          <Card className={`${styles.statusCard} rounded-4 bg-white`}>
            <CardBody>
              <SmallCardSkeleton />
            </CardBody>
          </Card>
        ) : (
          <div className="d-flex flex-wrap gap-4 align-items-start">
            {!completedStatus ? (
              <Card className={`${styles.statusCard} rounded-4 p-2 bg-white`}>
                <CardBody className="text-center">{resources.noData}</CardBody>
              </Card>
            ) : (
              <Card className={`${styles.statusCard} ${styles.completedStatus} rounded-4`}>
                <CardBody className="py-2 px-3">
                  <div className="d-flex align-items-center gap-2 justify-content-between mb-4">
                    <div className="fw-bold">
                      <Lock className="me-2 text-muted" />{' '}
                      <span>
                        <Dot width={32} height={32} />
                        {completedStatus?.name}
                      </span>
                    </div>
                    <span className="text-muted fw-bold text-uppercase">{resources.finalToggle}</span>
                  </div>
                  <NotifyToggle
                    statusId={completedStatus?.orderSystemStatusId ?? 0}
                    waNotificationTemplates={waNotificationTemplates ?? []}
                    isLoadingTemplates={isLoadingTemplates}
                  />
                </CardBody>
              </Card>
            )}

            {/* Cancelled Status */}
            {!cancelledStatus ? (
              <Card className={`${styles.statusCard} rounded-4 bg-white`}>
                <CardBody className="text-center">{resources.noData}</CardBody>
              </Card>
            ) : (
              <Card className={`${styles.statusCard} ${styles.cancelledStatus} rounded-4`}>
                <CardBody className="py-2 px-3">
                  <div className="d-flex align-items-center gap-2 justify-content-between mb-4">
                    <div className="fw-bold">
                      <Lock className="me-2 text-muted" />{' '}
                      <span>
                        <Dot width={32} height={32} />
                        {cancelledStatus?.name}
                      </span>
                    </div>
                    <span className="text-muted fw-bold text-uppercase">{resources.finalToggle}</span>
                  </div>
                  <NotifyToggle
                    statusId={cancelledStatus?.orderSystemStatusId ?? 0}
                    waNotificationTemplates={waNotificationTemplates ?? []}
                    isLoadingTemplates={isLoadingTemplates}
                  />
                </CardBody>
              </Card>
            )}
          </div>
        )}
        {/* </div> */}
      </div>
    </div>
  );
};

export default SystemStatusForm;
